export const featureFlag = {
  notificationSubscriptions: false
} as const;
